import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navigation.css';

export default function Navigation({ currentPage, userRole }) {
  const isAdmin = userRole === 'admin' || userRole === 'administrator';

  return (
    <nav className="tool-nav">
      <ul className="nav-menu">
        <li>
          <Link 
            to="/hub" 
            className={`nav-item ${currentPage === 'hub' ? 'active' : ''}`}
            style={{ background: 'rgba(255,255,255,0.05)', color: '#e2e8f0', border: '1px solid rgba(255,255,255,0.1)' }}
          >
            🏠 Tools Hub
          </Link>
        </li>
        <li>
          <Link 
            to="/video-audit" 
            className={`nav-item ${currentPage === 'video-audit' ? 'active' : ''}`}
            style={currentPage === 'video-audit' ? { background: 'linear-gradient(90deg, #8b5cf6, #ec4899)', color: '#ffffff', boxShadow: '0 0 15px rgba(236,72,153,0.3)' } : { background: 'rgba(236,72,153,0.1)', color: '#f472b6', border: '1px solid rgba(236,72,153,0.3)' }}
          >
            ✨ AI Video Audit (V2)
          </Link>
        </li>
        <li>
          <Link 
            to="/niche-research" 
            className={`nav-item ${currentPage === 'niche-research' ? 'active' : ''}`}
          >
            🎯 Niche Finder
          </Link>
        </li>
        <li>
          <Link 
            to="/upload-optimizer" 
            className={`nav-item ${currentPage === 'upload-optimizer' ? 'active' : ''}`}
          >
            📅 Upload Schedule
          </Link>
        </li>
        <li>
          <Link 
            to="/tag-gap" 
            className={`nav-item ${currentPage === 'tag-gap' ? 'active' : ''}`}
          >
            🏷️ Tag Gap
          </Link>
        </li>
        <li>
          <Link 
            to="/revenue-estimator" 
            className={`nav-item ${currentPage === 'revenue-estimator' ? 'active' : ''}`}
          >
            💰 Revenue Estimator
          </Link>
        </li>
        <li>
          <Link 
            to="/keyword-analysis" 
            className={`nav-item ${currentPage === 'analysis' ? 'active' : ''}`}
          >
            📊 SEO Keyword Analysis
          </Link>
        </li>
        <li>
          <Link 
            to="/comment-mining" 
            className={`nav-item ${currentPage === 'comment-mining' ? 'active' : ''}`}
          >
            💬 Comment Mining
          </Link>
        </li>
        <li>
          <Link 
            to="/pages/competitor" 
            className={`nav-item ${currentPage === 'competitor' ? 'active' : ''}`}
          >
            🏆 Competitor Intel
          </Link>
        </li>
        <li>
          <Link 
            to="/pages/trending" 
            className={`nav-item ${currentPage === 'trending' ? 'active' : ''}`}
          >
            🔥 Trending Topics
          </Link>
        </li>
        <li>
          <Link 
            to="/script-generator" 
            className={`nav-item ${currentPage === 'script-generator' ? 'active' : ''}`}
          >
            ✍️ AI Script Writer
          </Link>
        </li>
        <li>
          <Link 
            to="/history" 
            className={`nav-item ${currentPage === 'history' ? 'active' : ''}`}
          >
            🕒 Audit History
          </Link>
        </li>
        {isAdmin && (
          <li>
            <Link 
              to="/admin/observability" 
              className={`nav-item ${currentPage === 'observability' ? 'active' : ''}`}
              style={{ background: 'rgba(59, 130, 246, 0.1)', color: '#60a5fa', border: '1px solid rgba(59, 130, 246, 0.3)' }}
            >
              🛡️ Observability Stats
            </Link>
          </li>
        )}
      </ul>
    </nav>
  );
}
